export const CLEAR_PHOTOGRAPHER_INVOICE_COLLECTIONS_STATE =
    'CLEAR_PHOTOGRAPHER_INVOICE_COLLECTIONS_STATE';
export const GET_PHOTOGRAPHER_INVOICE_COLLECTION_LISTS_SUCCESS =
    'GET_PHOTOGRAPHER_INVOICE_COLLECTION_LISTS_SUCCESS';
export const GET_PHOTOGRAPHER_INVOICE_COLLECTION_SUCCESS =
    'GET_PHOTOGRAPHER_INVOICE_COLLECTION_SUCCESS';
